(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8c83"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8c83"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("aOxc0", function(module, exports) {

$parcel$export(module.exports, "esc", function () { return $7df852413cd4b2aa$export$a1a11b095f88289a; });
$parcel$export(module.exports, "productsUrl", function () { return $7df852413cd4b2aa$export$a85a56468e53d2a4; });
$parcel$export(module.exports, "PER_PAGE", function () { return $7df852413cd4b2aa$export$69732c3bb20f3062; });
$parcel$export(module.exports, "xSvg", function () { return $7df852413cd4b2aa$export$de73a2de604c6323; });
$parcel$export(module.exports, "productCard", function () { return $7df852413cd4b2aa$export$9a38ce2e48a70676; });
$parcel$export(module.exports, "updateDropdownCounts", function () { return $7df852413cd4b2aa$export$48117e474854b32a; });
$parcel$export(module.exports, "initChipRemove", function () { return $7df852413cd4b2aa$export$511bf9baa608f371; });
$parcel$export(module.exports, "initDropdownReset", function () { return $7df852413cd4b2aa$export$5de2f589d8d3a4e4; });
$parcel$export(module.exports, "initDropdowns", function () { return $7df852413cd4b2aa$export$8cb65a02593bf108; });
var $7df852413cd4b2aa$var$_window_kcaData;
var $7df852413cd4b2aa$export$a1a11b095f88289a = function(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
};
var $7df852413cd4b2aa$var$_window_kcaData_productsUrl;
var $7df852413cd4b2aa$export$a85a56468e53d2a4 = ($7df852413cd4b2aa$var$_window_kcaData_productsUrl = ($7df852413cd4b2aa$var$_window_kcaData = window.kcaData) === null || $7df852413cd4b2aa$var$_window_kcaData === void 0 ? void 0 : $7df852413cd4b2aa$var$_window_kcaData.productsUrl) !== null && $7df852413cd4b2aa$var$_window_kcaData_productsUrl !== void 0 ? $7df852413cd4b2aa$var$_window_kcaData_productsUrl : '/wp-json/kca/v1/products';
var $7df852413cd4b2aa$export$69732c3bb20f3062 = 12;
var $7df852413cd4b2aa$export$e0723991ed9379cc = '<svg xmlns="http://www.w3.org/2000/svg" width="24"\n  height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"\n  stroke-width="2" stroke-linecap="round" stroke-linejoin="round"\n  aria-hidden="true"><line x1="5" y1="12" x2="19" y2="12"/>\n  <polyline points="12 5 19 12 12 19"/></svg>';
var $7df852413cd4b2aa$export$de73a2de604c6323 = '<svg xmlns="http://www.w3.org/2000/svg" fill="none"\n  class="icon icon-close-small" viewBox="0 0 12 13" width="11"\n  height="11" aria-hidden="true"><path stroke="currentColor"\n  stroke-linecap="round" stroke-linejoin="round"\n  d="M8.486 9.33 2.828 3.67M2.885 9.385l5.544-5.77"/></svg>';
var $7df852413cd4b2aa$export$9a38ce2e48a70676 = function(p) {
    var img = p.thumbnail ? '<div class="products-listing__image">' + '<img src="'.concat($7df852413cd4b2aa$export$a1a11b095f88289a(p.thumbnail), '" alt="').concat($7df852413cd4b2aa$export$a1a11b095f88289a(p.title), '"></div>') : '<div class="products-listing__image products-listing__image--placeholder"></div>';
    return [
        '<li class="products-listing__item" role="listitem">',
        '<a href="'.concat($7df852413cd4b2aa$export$a1a11b095f88289a(p.link), '" class="products-listing__card">'),
        img,
        '<div class="products-listing__info">',
        '<h3 class="products-listing__title">'.concat($7df852413cd4b2aa$export$a1a11b095f88289a(p.title), "</h3>"),
        '</div>',
        '<div class="wp-block-button is-style-filled-red">',
        '<span class="wp-block-button__link">',
        "View details ".concat($7df852413cd4b2aa$export$e0723991ed9379cc),
        '</span></div>',
        '</a></li>'
    ].join('');
};
var $7df852413cd4b2aa$export$48117e474854b32a = function(checkboxSel) {
    document.querySelectorAll('.search-results__dropdown').forEach(function(dropdown) {
        var count = dropdown.querySelectorAll("".concat(checkboxSel, ":checked")).length;
        var dropCountEl = dropdown.querySelector('.search-results__dropdown-count');
        if (dropCountEl) dropCountEl.textContent = "".concat(count, " selected");
    });
};
var $7df852413cd4b2aa$export$511bf9baa608f371 = function(checkboxSel, onRemove) {
    document.addEventListener('click', function(e) {
        var chip = e.target.closest('.search-results__chip');
        if (!chip) return;
        var _chip_dataset = chip.dataset, taxonomy = _chip_dataset.taxonomy, slug = _chip_dataset.slug;
        var cb = document.querySelector("".concat(checkboxSel, '[data-taxonomy="').concat(taxonomy, '"][data-slug="').concat(slug, '"]'));
        if (cb) cb.checked = false;
        onRemove();
    });
};
var $7df852413cd4b2aa$export$5de2f589d8d3a4e4 = function(checkboxSel, onReset) {
    document.addEventListener('click', function(e) {
        var _btn_closest;
        var btn = e.target.closest('.search-results__dropdown-reset-inner');
        if (!btn) return;
        (_btn_closest = btn.closest('.search-results__dropdown')) === null || _btn_closest === void 0 ? void 0 : _btn_closest.querySelectorAll("".concat(checkboxSel, ":checked")).forEach(function(cb) {
            cb.checked = false;
        });
        onReset();
    });
};
var $7df852413cd4b2aa$export$8cb65a02593bf108 = function() {
    var SEL = '.search-results__dropdown';
    var SEL_BTN = "".concat(SEL, "-btn");
    var SEL_PANEL = "".concat(SEL, "-panel");
    document.querySelectorAll(SEL).forEach(function(dropdown) {
        var btn = dropdown.querySelector(SEL_BTN);
        var panel = dropdown.querySelector(SEL_PANEL);
        if (!btn || !panel) return;
        btn.addEventListener('click', function() {
            var isOpen = btn.getAttribute('aria-expanded') === 'true';
            document.querySelectorAll(SEL_BTN).forEach(function(b) {
                var _b_closest_querySelector, _b_closest;
                b.setAttribute('aria-expanded', 'false');
                (_b_closest = b.closest(SEL)) === null || _b_closest === void 0 ? void 0 : (_b_closest_querySelector = _b_closest.querySelector(SEL_PANEL)) === null || _b_closest_querySelector === void 0 ? void 0 : _b_closest_querySelector.setAttribute('hidden', '');
            });
            if (!isOpen) {
                btn.setAttribute('aria-expanded', 'true');
                panel.removeAttribute('hidden');
            }
        });
    });
    document.addEventListener('click', function(e) {
        if (!e.target.closest(SEL)) {
            document.querySelectorAll(SEL_BTN).forEach(function(b) {
                b.setAttribute('aria-expanded', 'false');
            });
            document.querySelectorAll(SEL_PANEL).forEach(function(p) {
                p.setAttribute('hidden', '');
            });
        }
    });
    document.addEventListener('keydown', function(e) {
        if (e.key !== 'Escape') return;
        document.querySelectorAll(SEL_BTN).forEach(function(b) {
            b.setAttribute('aria-expanded', 'false');
        });
        document.querySelectorAll(SEL_PANEL).forEach(function(p) {
            p.setAttribute('hidden', '');
        });
    });
};

});


var $aOxc0 = parcelRequire("aOxc0");
// "Load more" for blocks set to show all products (limit -1). Page 1 is
// rendered server-side; the block can appear several times on a page.
var $2d241f00f649ec99$var$initLoadMore = function(block) {
    var grid = block.querySelector('.products-listing__grid');
    var wrap = block.querySelector('.products-listing__load-more');
    var btn = wrap === null || wrap === void 0 ? void 0 : wrap.querySelector('.products-listing__load-more-btn');
    var errorEl = wrap === null || wrap === void 0 ? void 0 : wrap.querySelector('.products-listing__load-more-error');
    if (!grid || !btn) return;
    var _block_dataset = block.dataset, _block_dataset_category = _block_dataset.category, category = _block_dataset_category === void 0 ? '' : _block_dataset_category;
    // Must match the server-rendered first page, or pages overlap/skip.
    var perPage = Number(block.dataset.perPage) || (0, $aOxc0.PER_PAGE);
    var page = 1;
    btn.addEventListener('click', function() {
        // URL API keeps an existing query (e.g. ?rest_route= without pretty
        // permalinks); the base resolves the relative fallback productsUrl.
        var url = new URL((0, $aOxc0.productsUrl), window.location.href);
        url.searchParams.set('order', 'ASC');
        url.searchParams.set('page', page + 1);
        url.searchParams.set('per_page', perPage);
        if (category) url.searchParams.set('current_category', category);
        btn.disabled = true;
        if (errorEl) errorEl.hidden = true;
        fetch(url).then(function(r) {
            if (!r.ok) throw new Error("HTTP ".concat(r.status));
            return r.json();
        }).then(function(param) {
            var products = param.products, hasMore = param.has_more;
            var html = products.map((0, $aOxc0.productCard)).join('');
            grid.insertAdjacentHTML('beforeend', html);
            page += 1;
            wrap.hidden = !hasMore;
        }).catch(function(err) {
            // page is not advanced, so the next click retries the same page.
            // eslint-disable-next-line no-console
            console.error('[products-listing] load more failed', {
                url: url.href,
                page: page + 1,
                category: category,
                err: err
            });
            if (errorEl) errorEl.hidden = false;
        }).finally(function() {
            btn.disabled = false;
        });
    });
};
document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.products-listing').forEach($2d241f00f649ec99$var$initLoadMore);
});

})();
//# sourceMappingURL=script.js.map
